/*
 * Static site content (ported from the former FastAPI backend `content.py`).
 * The site is fully static — this module is the single source of truth that
 * the data layer in `src/lib/api.js` serves to the pages.
 */

export const IMG = {
  portrait: "https://images.pexels.com/photos/14259979/pexels-photo-14259979.jpeg",
  cs1: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMFVJJTIwZGF0YSUyMHZpc3VhbGl6YXRpb24lMjBkYXJrJTIwbW9kZXxlbnwwfHx8fDE3ODA2Nzk4NjN8MA&ixlib=rb-4.1.0&q=85",
  cs2: "https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg",
  cs3: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMFVJJTIwZGF0YSUyMHZpc3VhbGl6YXRpb24lMjBkYXJrJTIwbW9kZXxlbnwwfHx8fDE3ODA2Nzk4NjN8MA&ixlib=rb-4.1.0&q=85",
  cs4: "https://images.pexels.com/photos/17279853/pexels-photo-17279853.jpeg",
  workspace: "https://images.unsplash.com/photo-1650661926447-9efb2610f64c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwZGFyayUyMHdvcmtzcGFjZSUyMGFyY2hpdGVjdHxlbnwwfHx8fDE3ODA2Nzk4NjN8MA&ixlib=rb-4.1.0&q=85",
};

export const PROFILE = {
  id: "profile",
  name: "Nishant Gathwal",
  role: "UX Designer",
  location: "New Delhi, India",
  email: "nishantgathwal@gmail.com",
  linkedin: "https://www.linkedin.com/in/nishant-gathwal-8494b047/",
  headline: "Hi. I'm a UX designer based in New Delhi.",
  subheadline:
    "8+ years designing product experiences across travel, edtech, and HR & enterprise software — the last 4+ at HROne.",
  available: true,
  years_experience: 8,
  bio: [
    "I'm a user-experience designer who builds products from ideation to high-fidelity mockups — mapping user journeys and keeping every stakeholder aligned along the way. I studied design at IIT Hyderabad and computer science at NSIT, Delhi, and I've worked across travel, edtech, social-impact, and HR software.",
    "I started my career in 2013, designing for companies like Ixigo and TheGeeksLab. Between 2018 and 2021 I stepped away from design to prepare for the UPSC civil services exam — a detour that sharpened how I research, structure problems, and stay disciplined under pressure.",
    "Since late 2021 I've spent over four years as a Senior UX Designer at HROne, working across several projects in their B2B and B2C HR software for small and medium businesses — on web, Android, and iOS. I care as much about the outcome — adoption, clarity, task completion — as I do about the craft.",
  ],
  stats: [
    { value: "8+", label: "Years in UX design" },
    { value: "4+", label: "Years at HROne" },
    { value: "2013", label: "Designing since" },
    { value: "IIT-H", label: "Design education" },
  ],
};

export const STRENGTHS = [
  {
    title: "Clear & Simple Problem-Solving",
    description:
      "I break complex challenges into simple, actionable steps — keeping design intuitive for users and realistic for teams.",
    icon: "Compass",
  },
  {
    title: "Grounded in User Research",
    description:
      "From interviews to usability tests, I make user insight the foundation of every decision, keeping products aligned with real needs.",
    icon: "Search",
  },
  {
    title: "Design-to-Development Bridge",
    description:
      "I work closely with developers far beyond handoff, making sure every detail is implemented with quality and consistency.",
    icon: "GitMerge",
  },
  {
    title: "Collaborative by Nature",
    description:
      "With product managers, engineers, and stakeholders, I align diverse perspectives to balance user value with business goals.",
    icon: "Users",
  },
];

export const SERVICES = [
  {
    title: "Product Design",
    description:
      "End-to-end UX/UI for web and mobile enterprise products — from flows and wireframes to polished, production-ready interfaces.",
    icon: "Layers",
  },
  {
    title: "UX Research",
    description:
      "User interviews, usability testing, and synthesis that surface the real problem before a single pixel is drawn.",
    icon: "Search",
  },
  {
    title: "Design Systems",
    description:
      "Scalable component libraries and design tokens that keep teams consistent and shipping fast.",
    icon: "Boxes",
  },
  {
    title: "Prototyping & Testing",
    description:
      "Interactive prototypes to validate ideas early, de-risk decisions, and bring stakeholders along.",
    icon: "MousePointerClick",
  },
  {
    title: "Data & Analytics UX",
    description:
      "Turning dense dashboards, reports, and analytics into clear, decision-ready experiences.",
    icon: "BarChart3",
  },
  {
    title: "Design Consulting",
    description:
      "Design audits, advisory, and mentorship to level up product teams and processes.",
    icon: "Lightbulb",
  },
];

export const SKILLS = [
  {
    group: "Design",
    items: [
      "Product Design",
      "Interaction Design",
      "Information Architecture",
      "Wireframing",
      "Visual Design",
      "Design Systems",
    ],
  },
  {
    group: "Research",
    items: [
      "User Interviews",
      "Usability Testing",
      "Surveys",
      "Journey Mapping",
      "Heuristic Evaluation",
    ],
  },
  {
    group: "Tools",
    items: ["Figma", "Sketch", "Adobe Illustrator", "InVision", "Marvel", "Balsamiq", "Zeplin"],
  },
  {
    group: "Collaboration",
    items: [
      "Workshops",
      "Stakeholder Alignment",
      "Design-to-Dev Handoff",
      "Mentorship",
      "Agile",
    ],
  },
];

// No fabricated testimonials. Add real quotes from colleagues/managers here
// when you have them — the section auto-hides while this list is empty.
export const TESTIMONIALS = [];

/*
 * Real case studies, grounded in actual roles from the resume. The narrative
 * (overview / challenge / process / outcome) is written at a high level and is
 * accurate to the work; refine the details, add real metrics, and drop in real
 * product screens (replace `cover_image` / `gallery`) when you have them.
 */
export const CASE_STUDIES = [
  {
    slug: "hrone-hr-platform",
    title: "HROne — HR Software for SMEs",
    subtitle:
      "Designing B2B and B2C HR experiences for small and medium businesses across web, Android, and iOS.",
    category: "HR & Enterprise",
    year: "2021—Now",
    role: "Senior UX Designer",
    duration: "Dec 2021 – Present · 4+ years",
    platform: "Web · Android · iOS",
    cover_image: "",
    summary:
      "Over 4+ years as Senior UX Designer at HROne, I've worked across several projects in their B2B/B2C HR software for SMEs — turning dense HR, payroll, and people-management workflows into experiences that everyday teams can actually use.",
    tags: ["HR Software", "B2B SaaS", "Mobile", "Enterprise UX"],
    overview:
      "HROne builds HR and payroll software for small and medium businesses, where the people using it are rarely HR specialists — they're founders, office managers, and employees who just want to get something done. Across more than four years I've contributed to several projects spanning the suite on web and mobile: shaping flows, simplifying data-heavy screens, and keeping the experience consistent across platforms.",
    challenge:
      "HR software has to handle real complexity — attendance, payroll, leave, compliance, performance — without overwhelming non-expert users. The challenge is exposing the right depth at the right moment, and keeping a coherent experience across B2B admin tools and B2C employee-facing apps on three platforms.",
    process: [
      {
        title: "Understand the user",
        description:
          "I map the journeys of the different people who touch the product — admins, managers, and employees — to understand where today's flows create friction.",
      },
      {
        title: "Frame & wireframe",
        description:
          "I translate requirements into flows and wireframes, pressure-testing the structure with stakeholders before investing in high-fidelity design.",
      },
      {
        title: "High-fidelity design",
        description:
          "I design production-ready screens across web, Android, and iOS, keeping patterns consistent so the suite feels like one product.",
      },
      {
        title: "Collaborate to ship",
        description:
          "I stay close to product and engineering through build and release, making sure the shipped experience matches the intent.",
      },
    ],
    outcome:
      "An HR suite that meets SMEs where they are — clearer workflows and a more consistent experience across platforms, designed for people who don't have time to learn complicated software.",
    metrics: [],
    gallery: [],
    featured: true,
  },
  {
    slug: "ixigo-travel-redesign",
    title: "Ixigo — Travel App & Web Redesign",
    subtitle:
      "Redesigning flight discovery and a cabs experience for one of India's largest travel platforms.",
    category: "Travel · Consumer",
    year: "2015—16",
    role: "UX Designer",
    duration: "1 year",
    platform: "Web · Android · iOS",
    cover_image: "",
    summary:
      "At Ixigo I redesigned the flight listing experience for web and mobile, designed a Cabs app for Android and iOS, and worked on the Ixigo–Micromax integration.",
    tags: ["Travel", "Consumer Apps", "Mobile", "Redesign"],
    overview:
      "Ixigo is a high-traffic consumer travel platform where small UX improvements reach a large audience. I focused on the flight listing experience — how people compare and choose flights — across web and mobile, plus a dedicated Cabs app and the integration that brought Ixigo onto Micromax devices.",
    challenge:
      "Travel listings are dense by nature: prices, times, stops, airlines, and filters all competing for attention. The goal was to make comparison feel effortless on small screens while preserving the depth power-users rely on.",
    process: [
      {
        title: "Study the comparison task",
        description:
          "I looked closely at how travellers scan and compare options, and where the existing listings created hesitation or drop-off.",
      },
      {
        title: "Redesign the listing",
        description:
          "I reworked the flight listing hierarchy for web and mobile so the most decision-relevant information leads, with filtering that stays out of the way until needed.",
      },
      {
        title: "Design across surfaces",
        description:
          "I extended the work into a Cabs app for Android and iOS and supported the Ixigo–Micromax integration, keeping the experience consistent across platforms.",
      },
    ],
    outcome:
      "A cleaner, faster flight-comparison experience across web and mobile, plus new consumer surfaces (Cabs, Micromax) that extended Ixigo's reach.",
    metrics: [],
    gallery: [],
    featured: true,
  },
  {
    slug: "thegeekslab-product-design",
    title: "TheGeeksLab — Edtech & Social-Impact Apps",
    subtitle:
      "Designing learning and health products — from exam prep to a health-tracking app for rural women.",
    category: "Edtech · Social Impact",
    year: "2016—18",
    role: "Senior UX Designer",
    duration: "1.5 years",
    platform: "Web · Mobile",
    cover_image: "",
    summary:
      "As Senior UX Designer at TheGeeksLab, I designed flows for Mypat (exam prep for 12th-grade students), Schoolpat (teacher evaluation), the Asha app (health tracking for rural women), and Chapter (skill training for professionals).",
    tags: ["Edtech", "Health", "Mobile", "Product Design"],
    overview:
      "At TheGeeksLab I led UX across a range of products with very different audiences — students preparing for board and competitive exams, teachers managing evaluations, rural women tracking their health, and professionals building new skills. Each demanded designing from ideation through to high-fidelity mockups.",
    challenge:
      "Designing for such varied users — from exam-stressed students to first-time smartphone users in rural areas — meant meeting very different levels of digital literacy and context, while keeping each product focused on its core job.",
    process: [
      {
        title: "Map each audience",
        description:
          "For every product I built an understanding of who the user was and what they were really trying to accomplish, then mapped their journey end-to-end.",
      },
      {
        title: "Ideate to high fidelity",
        description:
          "I moved from concepts and flows to high-fidelity mockups, involving stakeholders throughout to keep designs grounded and buildable.",
      },
      {
        title: "Design for accessibility of use",
        description:
          "Especially for the Asha health app, I kept flows simple and forgiving for users with limited digital experience.",
      },
    ],
    outcome:
      "A portfolio of shipped products across edtech and social impact — Mypat, Schoolpat, Asha, and Chapter — each designed end-to-end for a distinct, real-world audience.",
    metrics: [],
    gallery: [],
    featured: false,
  },
];

// Blog/Journal removed — no posts. Section and routes are disabled in the app.
export const BLOGS = [];

export const SITE = {
  profile: PROFILE,
  strengths: STRENGTHS,
  services: SERVICES,
  skills: SKILLS,
  testimonials: TESTIMONIALS,
};
